import { z } from 'zod';
import { ResourceLibraryNewsBaseItem } from '../types/resourceLibraryItems';
import { GetResourceLibraryNewsItemListingSchema } from '../schemas/resourceLibraryNewsItemZodSchemas';
import { hydrateResourceLibraryNewsBaseItem } from './transformResourceLibraryNewsItemResponse';

/**
 * Transforms and validates the response from the getResourceLibraryNewsItemListing GraphQL query
 * to a simplified ResourceLibraryNewsItem[] type.
 *
 * @param data The response data from the getResourceLibraryNewsItemListing query
 * @returns An array of valid ResourceLibraryItem objects
 */
export function transformResourceLibraryNewsItemsResponse(
    data: unknown // GetResourceLibraryNewsItemListingQuery - use unknown for jest tests be able to
    // pass invalid data
): ResourceLibraryNewsBaseItem[] {
    // Parse and validate the data using the Zod schema
    const parsedResult = GetResourceLibraryNewsItemListingSchema.safeParse(data);

    if (!parsedResult.success) {
        console.error(
            'Validation failed for getResourceLibraryItemListing:',
            parsedResult.error.errors
        );
        return [];
    }

    const resourceNewsItemListingEdges = parsedResult.data.getResourceLibraryNewsItemListing.edges;

    // Transform resource items to simplified ResourceLibraryItem type
    return resourceNewsItemListingEdges.map(({ node }) => {
        const item = node as z.infer<
            typeof GetResourceLibraryNewsItemListingSchema
        >['getResourceLibraryNewsItemListing']['edges'][number]['node'];

        return hydrateResourceLibraryNewsBaseItem(item);
    });
}
